import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { H2 } from 'components/atoms/Typography';
import { MicroFrontEndEmbed } from 'components/core/MicroFrontEndEmbed';
import ErrorIcon from 'assets/images/icons/alert.svg';

import './Calculator.scss';

const ErrorBanner = ({ message }) => (
	<div className="error-banner">
		<img
			src={ErrorIcon}
			alt="Error icon"
		/>
		<span>{message}</span>
	</div>
);

ErrorBanner.propTypes = {
	message: PropTypes.string.isRequired,
};

const Calculator = ({ siteKey, data = null }) => {
	const [hasError, setHasError] = useState(false);

	return (
		<div className="calculator-container">
			<div className="top-size-text-container">
				<div className="top-size-heading-container">
					<H2
						size="large"
						color="black"
					>
						Self Storage Unit Size Calculator
					</H2>
				</div>
			</div>

			{hasError && (
				<ErrorBanner message="There was an issue loading the storage calculator. Try reloading the page or come back later." />
			)}

			<MicroFrontEndEmbed
				id={`st-storage-calculator-${siteKey}`}
				// to-do - update these URLs to be env specific if needed
				scriptURL={`https://storage-calculator-mfe.sparefoot.com/assets/index.js`}
				stylesheetURL={`https://storage-calculator-mfe.sparefoot.com/assets/index.css`}
				className="storage-calculator"
				data={{
					'data-site': siteKey,
					'data-type': 'calculator',
				}}
				config={data ? JSON.stringify(data) : null}
				onLoad={() => setHasError(false)}
				onError={() => setHasError(true)}
			/>
		</div>
	);
};

Calculator.propTypes = {
	siteKey: PropTypes.oneOf(['SFDC', 'SSDC', 'SDC']).isRequired,
	data: PropTypes.object,
};

export default Calculator;
